// services/paymentService.js
import axiosInstance from "../services/config/axiosinstance";

import { urlBase } from "./config";

export async function getCurrency() {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/currency`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar moedas", error);
    throw error;
  }
}

export async function getCurrencyEvent({ eventId }) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/currency-event/${eventId}/event`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar moedas", error);
    throw error;
  }
}

export async function postCurrencyEvent(data) {
  var config = {
    method: "post",
    url: `${urlBase}/currency-event`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}
